export default __webpack_public_path__ + "static/media/produk 3.6226ae01.png";